<div class="text-center">
    <mat-icon>developer_board</mat-icon>
    <br>
    <h1 mat-dialog-title translate> 
        dialog.quick.site.title
    </h1>
    
  
    <div class="modal-body" mat-dialog-content>
<!--
      <help-alert text = "help.page.new_service.field" info = "help.info" description = "help.page.new_service.description"></help-alert>
-->
      <div class="card container">

        <div class="row mt-2">
            <div class="col-md">
                <mat-form-field class = "full-width">
                  <mat-label translate>dialog.quick.site.numCodino</mat-label>
                  <input    [(ngModel)]="conf.numCodino" 
                            matInput
                            type    =   "number"
                            min     =   "0" 
                            required>
                </mat-form-field>
            </div>
            <div class="col-md">
                <mat-form-field class = "full-width">
                  <mat-label translate>dialog.quick.site.numCounter</mat-label>
                  <input    [(ngModel)]="conf.numCounter" 
                            matInput
                            type    =   "number"
                            min     =   "0" 
                            required>
                </mat-form-field>
            </div>
        </div>
        <!--
                    <div class="row mt-2">
            <div class="col-md">
                <mat-form-field class = "full-width">
                  <mat-label translate>dialog.quick.site.numOperator</mat-label>
                  <input    [(ngModel)]="conf.numOperator" 
                            matInput
                            type    =   "number"
                            min     =   "0" 
                            required>
                </mat-form-field>
            </div>
            <div class="col-md">
                <mat-form-field class = "full-width">
                  <mat-label translate>dialog.quick.site.numService</mat-label>
                  <input    [(ngModel)]="conf.numService"
                            matInput
                            type    =   "number"
                            min     =   "0" 
                            required>
                </mat-form-field>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md">
                <mat-form-field class = "full-width">
                  <mat-label translate>dialog.quick.site.numSummary</mat-label>
                  <input    [(ngModel)]="conf.numSummary" 
                            matInput
                            type    =   "number"
                            min     =   "0" 
                            required>
                </mat-form-field>
            </div>
        </div>
      </div>
        -->
        <div class="row mt-2">
            <div class="col-md">
                <mat-form-field class = "full-width">
                  <mat-label translate>dialog.quick.site.numService</mat-label>
                  <input    [(ngModel)]="conf.numService" 
                            matInput
                            type    =   "number"
                            min     =   "0" 
                            required>
                </mat-form-field>
            </div>
            <div class="col-md">
                <mat-form-field class = "full-width">
                  <mat-label translate>dialog.quick.site.numSummary</mat-label>
                  <input    [(ngModel)]="conf.numSummary" 
                            matInput
                            type    =   "number"
                            min     =   "0" 
                            required>
                </mat-form-field>
            </div>
        </div>
      </div>
    </div>
    
</div>
  
<div class="modal-footer" mat-dialog-actions translate>
  
    <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
        dialog.quick.site.generic.cancel
    </button>

    <button type="button" 
            [disabled] = "!checkValues()"
            class="btn btn-outline-secondary" 
            (click)="create()" 
            translate>
        dialog.quick.site.create.confirm
    </button>

</div>